import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { Call } from '@gem/call/CallStore/Call';
import { Opponent } from '@gem/call/CallStore/Opponent/Opponent';
import { useCallContext } from '@gem/call/CallView/CallView.context';

import { useOpponentsListSelector } from '../useOpponentsListSelector/useOpponentsListSelector';

interface IOpponentsVideo {
  opponentsList: readonly Opponent[];
  opponentsKeys: ProviderUid[];
  ongoingCall: Call;
  setOpponentsList(opponentsList: readonly Opponent[]): void;
}

export const useOpponentsVideo = (isGridLayout?: boolean): IOpponentsVideo => {
  const context = useCallContext();
  const opponentsList = useOpponentsListSelector();

  const presenter = useLocalObservable<IOpponentsVideo>(() => ({
    opponentsList: opponentsList,

    get ongoingCall(): Call {
      return context.call;
    },

    get opponentsKeys(): ProviderUid[] {
      const speakerOpponent = presenter.ongoingCall.viewState.speakerOpponent;

      const opponentsInitialPositions = isGridLayout
        ? presenter.opponentsList
        : presenter.opponentsList.filter(
            (opponent: Opponent) => opponent.uid !== speakerOpponent?.uid
          );

      const opponentsUids = opponentsInitialPositions.map((item: Opponent) => item.uid);
      const positions = presenter.ongoingCall.opponentsPositions.opponentsPositions;

      return opponentsUids.sort((uid1, uid2) => {
        const position1 = positions[uid1] ?? Infinity;
        const position2 = positions[uid2] ?? Infinity;
        return position1 - position2;
      });
    },

    setOpponentsList(opponentsList: readonly Opponent[]): void {
      presenter.opponentsList = opponentsList;
    },
  }));

  useEffect(() => {
    presenter.setOpponentsList(opponentsList);
  }, [opponentsList]);

  return presenter;
};
